/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Modal, Grid, Tooltip, Button } from '@mui/material';
import { Rnd } from 'react-rnd';
// web.cjs is required for IE11 support
// import { useSpring, animated } from 'react-spring/web.cjs';
import StreamTable from './streamdata-tables';
import { download_feed, closeIconBlack } from '../../shared/assets/images';
import './views.scss';
import SaveCSVFile from '../SaveCsv';

const Views = (props) => {
  const { viewOption, handleCloseOption, ediOutputData } = props;
  const { t } = useTranslation();
  const translateObject = t;
  const jsonData = JSON.parse(localStorage.getItem('stream_ouput_data')) || {};
  const defaultNum = Object.keys(jsonData)[0];
  const unitData = JSON.parse(localStorage.getItem('unit_set_dict')) || {};
  const [streamNum, setStreamNum] = useState(defaultNum);
  const [streamActive, setStreamActive] = useState(0);
  const defaultJsonData = jsonData[defaultNum];
  const [streamjsonData, setStreamjsonData] = useState(defaultJsonData);
  const [unit_set_dict] = useState(unitData);
  const [isLoading, setIsLoading] = useState(false);
  const [decimalVal, setDecimalVal] = useState(3);
  const [download_csv, setDownload_csv] = useState(false);
  const navlist_names = []; // creating steamdata name list
  Object.entries(jsonData).forEach(([key, value]) => {
    const obj = {}; // creating object
    obj.key = key;
    obj.label = value.label === null ? '' : value.label;
    navlist_names.push(obj); // pushing object values to steamdata list
  });
  useEffect(() => {
    const loader = setInterval(() => {
      setIsLoading(false);
    }, 200);
    return () => clearInterval(loader);
  }, [isLoading]);

  const streamData = (params, i) => {
    setStreamNum(params);
    setStreamActive(i);
    setStreamjsonData(jsonData[params]);
    setIsLoading(true);
    // GB-2259 chandrashekhar kumar added.
    setDecimalVal(3);
    if (ediOutputData && ediOutputData.length > 0) {
      for (let i = 0; i < ediOutputData.length; i += 1) {
        if (ediOutputData[i].data.text === Number(params)) {
          setDecimalVal(5);
          break;
        }
      }
    }
    // GB-2259 chandrashekhar kumar added.
  };
  function getValue(item, num) {
    return Number.parseFloat(item).toFixed(num);
  }
  const excelData = [
    { Ions: 'Ion', mg: 'mg/l', mgs: 'Molal' },
    { Ions: 'Calcium (Ca)', mg: getValue(streamjsonData.ppm_dict['Ca++'], 3), mgs: getValue(streamjsonData.molal_dict['Ca++'], 3) },
    { Ions: 'Magnesium (Mg)', mg: getValue(streamjsonData.ppm_dict['Mg++'], 3), mgs: getValue(streamjsonData.molal_dict['Mg++'], 3) },
    { Ions: 'Sodium (Na)', mg: getValue(streamjsonData.ppm_dict['Na+'], 3), mgs: getValue(streamjsonData.molal_dict['Na+'], 3) },
    { Ions: 'Potassium (K)', mg: getValue(streamjsonData.ppm_dict['K+'], 3), mgs: getValue(streamjsonData.molal_dict['K+'], 3) },
    { Ions: 'Ammonia - N (NH4)', mg: getValue(streamjsonData.ppm_dict['NH4+'], 3), mgs: getValue(streamjsonData.molal_dict['NH4+'], 3) },
    { Ions: 'Barium (Ba)', mg: getValue(streamjsonData.ppm_dict['Ba++'], 3), mgs: getValue(streamjsonData.molal_dict['Ba++'], 3) },
    { Ions: 'Strontium (Sr)', mg: getValue(streamjsonData.ppm_dict['Sr++'], 3), mgs: getValue(streamjsonData.molal_dict['Sr++'], 3) },
    { Ions: 'Iron (Fe)', mg: getValue(streamjsonData.ppm_dict['Fe++'], 3), mgs: getValue(streamjsonData.molal_dict['Fe++'], 3) },
    { Ions: 'Manganese (Mn)', mg: getValue(streamjsonData.ppm_dict['Mn++'], 3), mgs: getValue(streamjsonData.molal_dict['Mn++'], 3) },
    { Ions: 'Sulfate (SO4)', mg: getValue(streamjsonData.ppm_dict['SO4--'], 3), mgs: getValue(streamjsonData.molal_dict['SO4--'], 3) },
    { Ions: 'Chloride (Cl)', mg: getValue(streamjsonData.ppm_dict['Cl-'], 3), mgs: getValue(streamjsonData.molal_dict['Cl-'], 3) },
    { Ions: 'Fluoride (F)', mg: getValue(streamjsonData.ppm_dict['F-'], 3), mgs: getValue(streamjsonData.molal_dict['F-'], 3) },
    { Ions: 'Nitrate (NO3)', mg: getValue(streamjsonData.ppm_dict['NO3-'], 3), mgs: getValue(streamjsonData.molal_dict['NO3-'], 3) },
    { Ions: 'Bromide (Br)', mg: getValue(streamjsonData.ppm_dict['Br-'], 3), mgs: getValue(streamjsonData.molal_dict['Br-'], 3) },
    { Ions: 'Phosphate (PO4)', mg: getValue(streamjsonData.ppm_dict['PO4---'], 3), mgs: getValue(streamjsonData.molal_dict['PO4---'], 3) },
    { Ions: 'Boron (B)', mg: getValue(streamjsonData.ppm_dict['B-'], 3), mgs: getValue(streamjsonData.molal_dict['B(OH)3'], 3) },
    { Ions: 'Silica (SiO2)', mg: getValue(streamjsonData.ppm_dict.SiO2, 3), mgs: getValue(streamjsonData.molal_dict.H4SiO4, 3) },
    { Ions: 'Hydrogen Sulfide (H2S)', mg: getValue(streamjsonData.ppm_dict.H2S, 3), mgs: getValue(streamjsonData.molal_dict.H2S, 3) },
    { Ions: 'Bicarbonate (HCO3)', mg: getValue(streamjsonData.ppm_dict['HCO3-'], 3), mgs: getValue(streamjsonData.molal_dict['HCO3-'], 3) },
    { Ions: 'Carbon Dioxide (CO2)', mg: getValue(streamjsonData.ppm_dict.CO2, 3), mgs: getValue(streamjsonData.molal_dict.CO2, 3) },
    { Ions: 'Carbonate (CO3)', mg: getValue(streamjsonData.ppm_dict['CO3--'], 3), mgs: getValue(streamjsonData.molal_dict['CO3--'], 3) },
    { Ions: 'Alkalinity', mg: getValue(streamjsonData.prop_dict.malk, 2), mgs: '' },
    { Ions: `Temperature ${unit_set_dict.Temperature === '°C' ? '(deg C)' : '(deg F)'}`, mg: getValue(streamjsonData.prop_dict.temp, 2), mgs: '' },
    { Ions: 'pH', mg: getValue(streamjsonData.prop_dict.ph, 2), mgs: '' }
  ];
  const exelarry = [];
  exelarry.push([`Water Composition of Stream '${streamNum}'`, '', '']);
  excelData.map((f) => {
    exelarry.push([f.Ions, f.mg, f.mgs]);
  });
  const csvData = exelarry;
  const closeCSV = () => {
    setDownload_csv(false);
  };
  return (
    <Modal
      hideBackdrop
      open={viewOption}
      onClose={handleCloseOption}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="views-modal"
    >
      <Box className=''>
        <Rnd
          default={{
            width: '75%',
            x: ((window.innerWidth / 2) - ((75 * (window.innerWidth / 100)) / 2)),
            y: 0
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick={false}
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '10px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='40%'
          cancel=".no_drag"
          className='views-box'>
          <Grid container className='views-grid-container'>
            <Grid item xs={12} className='views-header-grid'>
              <div className='views-header-text rufusBld no_drag S_heading'>{translateObject('Stream Data')}</div>
              <div className='views-close-icon no_drag' style={{ marginRight: '16px', marginTop: '0px', marginBottom: '4px' }}>
                <Tooltip title="Download as csv" placement="top" arrow>
                  <img
                    onClick={() => { setDownload_csv(true); }}
                    src={download_feed}
                    alt="close"
                    style={{ width: '24px', padding: '7px', height: '24px' }}
                    className="pointer"
                  />
                </Tooltip>
                <Tooltip title="Close" placement="top" arrow>
                  <img
                    src={closeIconBlack}
                    alt="close"
                    aria-label="save"
                    onClick={handleCloseOption}
                    style={{ width: '14px', padding: '6px 0px 11px 7px' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} style={{ height: 'auto', overflow: 'hidden' }} className='views-content-grid views-height'>
              <div className="card-container">
                <Grid container style={{ height: '80vh', overflow: 'scroll' }}>
                  <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                    <h5 className="view-sub-title rufusBld no_drag M_heading">{translateObject('Streams')}</h5>
                    <div className="info-timeline">
                      <ul className="stream-scroller" style={{ height: '65vh' }}>
                        {navlist_names.map((item, i) => (
                          <li key={`aa${Math.random().toString(36).slice(2, 7)}`} style={{ position: 'relative' }}>
                            <span className={streamActive === i ? 'SteamActived timeline-circle' : 'SteamUNActived timeline-circle'}
                              style={{ backgroundColor: streamActive === i ? '#0679CC' : '#E0DDEE', color: streamActive === i ? '#FCFCFC' : '75748B' }}
                              onClick={() => streamData(item.key, i)} >
                              {item.key}
                            </span>
                            <span id="align-value" className={streamActive === i ? 'SteamActived no_drag' : 'SteamUNActived no_drag'}
                              onClick={() => streamData(item.key, i)}>{item.label}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
                    <div style={{ display: isLoading ? '' : 'none' }}>
                      <div className="pleaseWaitText" style={{ color: '#000' }}> {translateObject('Loading Please wait...')}</div></div>
                    <div style={{ display: isLoading ? 'none' : '' }}>
                      <StreamTable streamNum={streamNum} unit_set_dict={unit_set_dict}
                        streamjsonData={streamjsonData} handleCloseOption={handleCloseOption} decimalVal={decimalVal} translateObject={translateObject} />
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          {/* by sudarsana Add buttons under stream data form into different Div component */}
          <Grid item xs={12} className="stream-btn" style={{ 'padding': '0px', height: '45px', borderTop: '1px solid #ccc', background: 'white' }}>
            <Grid container spacing={2} alignItems="stretch" id='streamDataBtnCont' style={{ 'padding': '5px 20px 5px 5px', marginTop: '0.1%' }}>
              <Grid item xs={6} sm={7} lg={10} style={{ paddingTop: '0px' }}>&nbsp;</Grid>
              <Grid item xs={3} sm={4} lg={1.8} style={{ paddingTop: '0px' }}>
                <Button
                  id='streamDataOkBtn'
                  size="small"
                  className="M_Bold"
                  variant="contained"
                  data-testid="ok-button"
                  style={{ backgroundColor: '#CCE4FF', color: '#002D62', 'marginRight': '16px' }}
                  onClick={handleCloseOption}> {translateObject('OK')}
                </Button>
              </Grid>
              <Grid item xs={3} sm={1} lg={0.2} />
            </Grid>
          </Grid>
          {download_csv && <SaveCSVFile data={csvData} closeCSV={closeCSV} />}
        </Rnd>
      </Box>
    </Modal>
  );
};
export default Views;